module.exports = __webpack_public_path__ + "img/qrcode.381d77b3.jpg";